import { useCallback, useContext } from 'react';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { useSub } from '@core/event-bus';

import { useBranchInspectionsTableColumns } from './use-branch-inspections-table-columns';
import { BranchInspectionsTableContext } from '../../contexts';

export const useBranchInspectionsTable = () => {
  const history = useHistory();
  const location = useLocation();
  const { fetch } = useContext(BranchInspectionsTableContext);
  const columns = useBranchInspectionsTableColumns();

  const getRowProps = useCallback(
    (id) => ({
      onDoubleClick: () => {
        history.push(generatePath('/@next/branch-inspections/:id/details', { id }), { background: location });
      },
    }),
    [history, location],
  );

  useSub(['@branch-inspections/update/succeed', '@branch-inspections/create/succeed'], () => {
    fetch();
  });

  return {
    columns,
    getRowProps,
  };
};
